import { FormattedPricingTier, PricingTier } from '~/types/miscellaneous';

const getPricingTierForQuantity = (
    quantity: number,
    pricingTiers: PricingTier[],
): PricingTier | null => {
    let pricingTier: PricingTier | null = null;

    for (let i = 0; i < pricingTiers.length; i++) {
        if (quantity >= pricingTiers[i].quantityBreak) {
            pricingTier = pricingTiers[i];
        }
    }

    return pricingTier || null;
};

const formatPricingTier = (
    pricingTier: PricingTier,
    basePricingTier: PricingTier | null = null,
): FormattedPricingTier => {
    let discountPercentage = null;
    if (basePricingTier && basePricingTier.price !== pricingTier.price) {
        discountPercentage = Math.round(
            (1 - pricingTier.price / basePricingTier.price) * 100,
        );
    }

    return {
        quantityBreakFormatted: commaNumber(pricingTier.quantityBreak),
        priceFormatted: formatCurrency(pricingTier.price),
        totalFormatted: formatCurrency(
            pricingTier.quantityBreak * pricingTier.price,
        ),
        discountPercentage,
        ...pricingTier,
    };
};

export { getPricingTierForQuantity, formatPricingTier };
